import { apiRequest } from "./apiClient";

export const spendCleaningService = {
  getLatestRecord: async () => {
    const data = await apiRequest("/api/spend-cleaning-latest");
    return Array.isArray(data) ? data[0] ?? null : data ?? null;
  },

  getAllRecords: async () => {
    return apiRequest(
      "/api/spend-cleaning"
    );
  },

  getById: async (id: number) => {
    return apiRequest(
      `/api/spend-cleaning/${id}`
    );
  },

  saveDataCleaningRecord: async (payload: any) => {
    return apiRequest(
      "/api/spend-cleaning",
      {
        method: "POST",
        body: JSON.stringify(payload)
      }
    );
  }
};